module.exports = __webpack_public_path__ + "static/media/206-306.0703253b.png";